/**
 * Adds a nested path to a given path.
 *
 * @param nestedPath - The existing nested path, if any.
 * @param path - The path to be added.
 */
export const addNestedPath = (nestedPath: string | undefined, path: string) =>
  nestedPath ? `${nestedPath}.${path}` : path;
